import React, {
  startTransition,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { fetcher as fetcherAPI } from '../../helpers/fetcher'
import { isEmpty } from '../../helpers/utils'
import { ACTIONS } from '../../store/Actions'
import { DataContext } from '../../store/GlobalState'
import './index.css'

const CardBody = ({ card }) => {
  const cardBodyRef = useRef()
  const cardBodyRef2 = useRef()

  const {
    state: { langForTransState, isTranslated },
    dispatch,
  } = useContext(DataContext)

  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(
    () => cardBodyRef.current?.innerHTML,
  )
  useEffect(() => {
    startTransition(() => {
      dispatch({
        type: ACTIONS.DATAFORTRANSLATIONCARDBODY,
        payload: {
          body: translations?.res1?.data,
        },
      })
    })
  }, [translations, dispatch])

  useEffect(() => {
    const fetcher = async () => {
      const res1 = await fetcherAPI.translation(
        'en',
        langForTransState,
        originalTitle,
      )
      settranslations(() => {
        return {
          res1,
        }
      })
    }
    !!isTranslated && !!originalTitle && fetcher()
  }, [isTranslated, originalTitle, langForTransState])

  useEffect(() => {
    if (!!card?.narrative && !isEmpty(card)) {
      if (true) {
        if (!!cardBodyRef.current?.innerHTML && !cardBodyRef2.current) {
          cardBodyRef2.current = cardBodyRef.current?.innerHTML
        }
        !!cardBodyRef2.current &&
          !originalTitle &&
          setoriginalTitle(() => cardBodyRef2.current)

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD2,
        //   payload:  true
        // })
      }
    }
  }, [isTranslated, card, dispatch, originalTitle])

  useEffect(() => {
    startTransition(() => {
      setTimeout(() => {
        dispatch({
          type: ACTIONS.NARRATIVEDOM,
          payload: cardBodyRef.current?.outerHTML,
        })
      }, 1000)
    })
  }, [isTranslated, dispatch, originalTitle, translations])

  return card && !isEmpty(card) ? (
    <>
      {card?.narrative && !isTranslated ? (
        <div
          ref={cardBodyRef}
          id="card-body"
          style={{
            marginTop: '30px',
            fontFamily: 'L10',
            fontStyle: 'normal',
            // fontSize: '13px',
            lineHeight: '20px',
          }}
          dangerouslySetInnerHTML={{ __html: card?.narrative }}></div>
      ) : (
        <>
          {!!isTranslated && (
            <div
              ref={cardBodyRef}
              id="card-body"
              style={{
                marginTop: '30px',
                fontFamily: 'L10',
                fontStyle: 'normal',
                // fontSize: '13px',
                lineHeight: '20px',
              }}
              dangerouslySetInnerHTML={{
                __html: translations?.res1?.data,
              }}></div>
          )}
        </>
      )}
    </>
  ) : null
}

export default CardBody
